import Calendar from "components/commons/Calendar";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { HealthEventCard } from "./HealthEventCard";
import WarningMessage from "components/commons/WarningMessage";

export const HealthEventCalendar = ({
    healthEvents = [],
    showUser = true,
    onDataChange = () => { },
    onEventClick = () => { },
}) => {

    const [t] = useTranslation(["global", "health"])
    const [criticOnly, setCriticOnly] = useState(false)
    const [selectedType, setSelectedType] = useState("ALL");
    const [selectedUser, setSelectedUser] = useState("ALL");

    function isCritic(type) {
        switch (type) {
            case "ECG":
            case "SPO2":
            case "BIA": return false
            default: return true
        }
    }

    const criticalOrNonCriticalEvent = useMemo(() => {
        return healthEvents.filter((event) => !criticOnly || isCritic(event.type))
    }, [healthEvents])

    const filteredEvents = useMemo(() => {
        return healthEvents.filter((event) => {
            const typeMatches = selectedType === "ALL" || event.type === selectedType;
            const userMatches = selectedUser === "ALL" || event.user.guid == selectedUser
            const statusMatches = !criticOnly || isCritic(event.type);
            return typeMatches && userMatches && statusMatches;
        });
    }, [healthEvents, selectedType, selectedUser, criticOnly]);


    let events = filteredEvents.map(healthEvent => {

        const startDate = new Date(healthEvent.timestamp * 1000);
        const endDate = new Date(healthEvent.timestamp * 1000 + 5 * 60 * 1000); // durata fittizia di 5 minuti
        return {
            id: healthEvent.user.guid + healthEvent.timestamp,
            title: t(`health:entity.events.${healthEvent.type}`),
            start: startDate,
            end: endDate,
            allDay: false,
            color: "black",
            className: "custom-health-event", // classe per stilizzazione
            display: "block",
            extendedProps: {
                eventDto: healthEvent
            }
        };
    });

    // Tipi e stati unici derivati dai dati
    const eventTypes = useMemo(() => {
        const types = new Set(criticalOrNonCriticalEvent.map((a) => a.type));
        return ["ALL", ...Array.from(types)];
    }, [filteredEvents]);

    // Lista pazienti distinti derivati dai dati
    const eventPeople = useMemo(() => {
        const people = criticalOrNonCriticalEvent.map((a) => a.user)
        const arrayUniqueByKey = [...new Map(people.map(item =>
            [item["guid"], item])).values()];
        return arrayUniqueByKey
    }, [filteredEvents]);

    function renderEventContent(eventInfo) {
        return <HealthEventCard event={eventInfo.event.extendedProps.eventDto} showUser={showUser} template="COMPACT" />
    }

    const clearFilters = () => {
        setSelectedType("ALL")
        setSelectedUser("ALL")
        setCriticOnly(false)
    }

    const isAnyFilterApplied = () => {
        return selectedType != "ALL" || selectedUser != "ALL" || criticOnly
    }

    return (
        <>
            <div className="row p-2">
                <div className="col-auto d-flex align-items-center">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" onChange={() => { setSelectedType("ALL"); setCriticOnly(!criticOnly) }} checked={criticOnly} id="flexCheckDefault" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            {t("health:actions.see_critical_events_only")}
                        </label>
                    </div>

                </div>
                <div className="col-auto d-flex align-items-center gap-2">
                    <label>
                        {t(`safety:entity.alarm.props_label.type`)}:
                    </label>
                    <select
                        className="form-select"
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                    >
                        {eventTypes.map((type) => (
                            <option key={type} value={type}>
                                {t(`health:entity.events.${type}`)}
                            </option>
                        ))}
                    </select>

                </div>
                {
                    showUser &&
                    <div className="col-auto d-flex align-items-center gap-2">
                        <label>
                            {t(`entity.employee`)}:
                        </label>
                        <select
                            className="form-select"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value)}
                        >
                            <option key="ALL" value="ALL">{t("particles.any")}</option>
                            {eventPeople.map((user) => (
                                <option key={user.guid} value={user.guid}>
                                    {user.displayName}
                                </option>
                            ))}
                        </select>

                    </div>
                }

            </div>
            <div className="d-flex">
                {isAnyFilterApplied() && <WarningMessage message={<>{t("helper.filter_applied_warning")}  <button className="btn btn-primary" onClick={clearFilters}><i className="fa-solid fa-xmark"></i> {t("action.clear_filter")}</button></>} />}

            </div>

            <Calendar
                events={events}
                onMonthChange={onDataChange}
                onEventClick={onEventClick}
                renderEventContent={renderEventContent}
            />

        </>)


}